module.exports = require('../lib/locale/en_US');